import { fromJS } from 'immutable';

export default {
    setUsers: (state, users) => {
        return state.setIn(['list'], fromJS(users)).set('initialized', true);
    },
    setUser: (state, userId, user) => {
        return state.mergeIn(['list', userId.toString()], fromJS(user));
    },
    updateUser: (state, userId, userDetails) => {
        return state.mergeIn(['list', userId.toString()], fromJS(userDetails));
    },
    addUser: (state, userId, userDetails) => {
        return state.setIn(['list', userId.toString()], fromJS(userDetails));
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/Users/core.js